import type { FormItem } from './types'

/** CmForm 表单项未传 placeholder 时默认使用 label（不使用「请输入/请选择」前缀） */
export function useCmFormDefaultPlaceholder() {
  function defaultPlaceholder(item: FormItem<any, any>) {
    return item.placeholder ?? item.label ?? ''
  }

  function placeholderInput(item: FormItem<any, any>) {
    return defaultPlaceholder(item)
  }

  function placeholderSelect(item: FormItem<any, any>) {
    return defaultPlaceholder(item)
  }

  return { placeholderInput, placeholderSelect }
}
